module.exports = __webpack_public_path__ + "front/img/u7.20103ba2.jpg";